import React from "react";
import { motion } from "framer-motion";
import {
  FaBus,
  FaGlobeAsia,
  FaBookOpen,
  FaMapMarkedAlt,
  FaUserGraduate,
} from "react-icons/fa";

// 👇 YAHAN APNI IMAGE IMPORT KARO
import educationalTrip from "../assets/trip...jpeg";

const features = [
  {
    title: "Experiential Learning",
    icon: <FaBookOpen />,
    desc: "Students understand concepts practically through real-world experiences and observations.",
  },
  {
    title: "Educational Exploration",
    icon: <FaMapMarkedAlt />,
    desc: "Trips encourage students to explore places, cultures and innovative ideas.",
  },
  {
    title: "Student Engagement",
    icon: <FaUserGraduate />,
    desc: "Interactive activities during tours improve confidence, teamwork and communication.",
  },
  {
    title: "Global Exposure",
    icon: <FaGlobeAsia />,
    desc: "Students broaden their perspectives through meaningful educational journeys.",
  },
];

const EducationalTrips = () => {
  return (
    <section className="bg-[#f8fbff]">

      {/* HERO */}
      <section className="bg-gradient-to-r from-[#07294d] to-[#0b3d68] py-20">
        <div className="max-w-6xl mx-auto px-6 text-center">

          <motion.div
            initial={{ opacity: 0, y: 35 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >

            <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-6 text-white text-4xl">
              <FaBus />
            </div>

            <p className="uppercase tracking-[5px] text-[#d4af37] font-bold">
              Cambridge International School
            </p>

            <h1 className="text-5xl md:text-6xl font-black text-white mt-6">
              Educational Trips
            </h1>

            <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>

          </motion.div>

        </div>
      </section>


      {/* CONTENT */}
      <section className="max-w-6xl mx-auto px-6 py-16">

        <motion.div
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="bg-white rounded-[30px] shadow-xl overflow-hidden"
        >

          <div className="grid md:grid-cols-2 items-stretch">

            {/* IMAGE */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="relative min-h-[400px] md:min-h-[500px] overflow-hidden"
            >

              <img
                src={educationalTrip}
                alt="Students on Educational Trip"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-[#07294d]/50 via-transparent to-transparent"></div>

            </motion.div>


            {/* TEXT */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="p-10 md:p-12 flex flex-col justify-center"
            >

              <h2 className="text-4xl font-black text-[#07294d] mb-6">
                Education Trips
              </h2>

              <div className="w-20 h-1 bg-[#d4af37] rounded-full mb-8"></div>

              <p className="text-gray-600 text-lg leading-9">
                Inside the classroom, a student gets to know about new things,
                new ideas and new concepts, while outside the classroom a
                student explores and experiences.
              </p>

              <p className="text-gray-600 text-lg leading-9 mt-5">
                The school always takes an initiative to organize an
                educational trip for the students so that they get to delve
                deep into experiential learning.
              </p>

              <p className="text-gray-600 text-lg leading-9 mt-5">
                The basic idea behind the educational trips is to let students
                know more, dig deep into many concepts and explore them
                through real-world experiences.
              </p>

            </motion.div>

          </div>

        </motion.div>

      </section>


      {/* FEATURES */}
      <section className="max-w-7xl mx-auto px-6 pb-20">

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">

          {features.map((item, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: index * 0.08,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              className="bg-white rounded-[28px] shadow-lg border border-gray-100 p-8 text-center transition-shadow duration-300 hover:shadow-2xl"
            >

              <div className="w-20 h-20 mx-auto rounded-2xl bg-[#07294d]/10 text-[#07294d] flex items-center justify-center text-4xl mb-6">
                {item.icon}
              </div>

              <h3 className="text-2xl font-bold text-[#07294d] mb-5">
                {item.title}
              </h3>

              <div className="w-16 h-1 bg-[#d4af37] rounded-full mx-auto mb-5"></div>

              <p className="text-gray-600 leading-8">
                {item.desc}
              </p>

            </motion.div>

          ))}

        </div>

      </section>

    </section>
  );
};

export default EducationalTrips;